function DashboardData() {
    "use strict";

    this.IsExpanderVisible = false;
    this.PendingDataItemCount = 5;
    this.ListViewPanel = null;
    this.EventList = [];
    this.CacheList = [];
    this.ConfirmStepCount = 0;
    this.IsCacheInitialized = false;
    this.IsDataIntitialized = false;
    this.IsFullReportInitialized = false;

    this.DataDirty = null;
    this.DataPaginated = null;
    this.EventData = null;
    this.EventDataPaginated = null;
    this.EnrolleeSelected = null;

    this.EventDebug = [];

    // report data
    this.ReportData = null;

    // last track enrollee id
    this.LastTrackEnrolleeId = -1;
    this.EventReportIconsStatus = false;
}
if (typeof exports !== 'undefined') {
    module.exports = DashboardData;
}